// This file is auto-generated by running `yarn svg:process`

import * as React from 'react'

export const IconCommentsSvg = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => {
  return (
    <svg
      viewBox="0 0 59 46"
      xmlns="http://www.w3.org/2000/svg"
      height={props.height}
      width={props.width}
      fill={props.fill}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.65 4.313A1.812 1.812 0 0124.462 2.5H44.41a1.814 1.814 0 011.814 1.813v10.875A1.812 1.812 0 0144.41 17h-7.254v7.25a1.812 1.812 0 01-1.813 1.813h-3.627v3.625a1.812 1.812 0 01-1.814 1.812h-1.389a1.814 1.814 0 01-1.393-.652l-3.99-4.785h-7.736a1.814 1.814 0 01-1.813-1.813V13.375a1.812 1.812 0 011.813-1.813h7.254v-7.25zm0 9.062h-7.255V24.25h7.737a1.814 1.814 0 011.392.652l3.99 4.785h1.39v-3.625a1.812 1.812 0 011.813-1.812h3.627v-5.653l-2.659 3.19a1.814 1.814 0 01-1.393.65h-1.389a1.814 1.814 0 01-1.813-1.812V17h-3.627a1.814 1.814 0 01-1.814-1.813v-1.812zM44.41 4.312H24.463v10.875h3.627A1.814 1.814 0 0129.903 17v3.625h1.39l3.99-4.785a1.812 1.812 0 011.392-.652h7.736V4.312z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.09 12.469V7.03h1.813v5.438H28.09zm5.44 0V7.03h1.814v5.438H33.53zm5.44 0V7.03h1.814v5.438h-1.813z"
      />
    </svg>
  )
}
